import { render } from "./advance-list.vue?vue&type=template&id=15079d94&scoped=true&ts=true"
import script from "./advance-list.vue?vue&type=script&lang=ts"
export * from "./advance-list.vue?vue&type=script&lang=ts"

import "./advance-list.vue?vue&type=style&index=0&id=15079d94&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15079d94"]])

export default __exports__